<template>
  <div class="card mb-2">
    <div class="card-header d-flex align-items-center" style="background: #eeeeee; color: #000000;">
      <div class="pr-2">
        <div  v-if="resource.logo_url !== null">
          <img :src="resource.logo_url" alt="" style="cursor: pointer; max-height: 50px">
        </div>
        <div  v-if="resource.logo_url === null">
        </div>
        <div class="d-flex justify-content-center">
          <span style="font-size: 0.5em; cursor: pointer" @click="setEditor('logo')">UPLOAD</span>
        </div>
      </div>
      <div class="d-flex align-items-center">
        <div style="font-size: 1.8em;">{{ resource.name }}</div>
        <div class="d-flex align-items-center pl-2" style="font-size: 0.8em;">
          <span v-if="resource.twitter_screen_name !== null">
            <a :href="'https://twitter.com/' + resource.twitter_screen_name" target="_blank"><i class="fab fa-twitter pr-2"></i></a>
          </span>
            <span v-if="resource.linkedin_url !== null">
            <a :href="resource.linkedin_url" target="_blank"><i class="fab fa-linkedin pr-2"></i></a>
          </span>
            <span v-if="resource.url !== null">
            <a :href="resource.url" target="_blank"><i class="fas fa-link pr-2"></i></a>
          </span>
        </div>
      </div>
      <div class="ml-auto d-flex flex-column align-items-end">
        <div>
          <span v-if="resource.needs_updating">
            <i class="fas fa-flag" v-b-tooltip.hover title="Resource has not been updated in 30 days."></i>
          </span>
          <i class="fas fa-pen-square p-1" style="cursor: pointer;" @click="setEditor('detail')"></i>
        </div>
        <div style="font-size: 0.75em;">
          Created On:
          <span v-if="resource.when_created === null">
            NO DATA
          </span>
          <span>
            {{ resource.when_created | formatDate }}
          </span>
        </div>
        <div style="font-size: 0.75em;">
          Last Updated:
          <span v-if="resource.last_updated === null">
            NO DATA
          </span>
          <span>
            {{ resource.last_updated | formatDate }}
          </span>
        </div>
      </div>
    </div>
    <div class="card-body">
      <transition name="fade">
        <div v-if="!isEditing">
          <!-- Description -->
          <div v-if="resource.description !== null">
            Description: <span style="font-weight: 300">{{ resource.description }}</span>
          </div>
          <div v-else class="text-center" style="font-weight: 700">
            NO DESCRIPTION
          </div>
          <!-- Location -->
          <div class="mt-2 d-flex">
            <div class="flex-fill">
              Location: <span style="font-weight: 300">{{ location }}</span>
            </div>
            <div class="flex-fill">
              Email: <span style="font-weight: 300">{{ resource.email }}</span>
            </div>
            <div class="flex-fill">
              Phone: <span style="font-weight: 300">{{ resource.phone }}</span>
            </div>
          </div>
          <!-- Tags -->
          <hr/>
          <div class="">
            <div class="d-flex align-items-center">
              <div>
                TAGS
              </div>
              <div class="ml-auto">
                <span @click="showTagAdder = !showTagAdder" style="font-weight: 300; font-size: 0.7em; cursor: pointer">
                  [ADD TAG]
                </span>
              </div>

            </div>
            <div v-if="showTagAdder">
              <resource-tag-adder v-on:tagAdded="(e) => tagAdded(e)" v-bind:resource="resource" v-bind:tag-type="'investor_target_size'"/>
            </div>
            <!-- Resource Type -->
            <div class="d-flex flex-wrap align-items-center">
              <span>Resource Type: </span>
              <div class="d-flex flex-wrap">
                <div class="p-1" v-for="tag in resource.tags.filter((x) => x.type === 'investor_tag')" :key="tag.id">
                  <resource-tag v-bind:tag="tag" v-bind:resource-i-d="resource.id" v-on:tagRemoved="(e) => tagRemoved(e)"/>
                </div>
              </div>
            </div>
            <!-- Target Area -->
            <div class="d-flex flex-wrap align-items-center">
              <span>Resource Target Area/Type: </span>
              <div class="d-flex flex-wrap align-items-center">
                <div class="p-1" v-for="tag in resource.tags.filter((x) => x.type === 'investor_target_area')" :key="tag.id">
                  <resource-tag v-bind:tag="tag" v-bind:resource-i-d="resource.id" v-on:tagRemoved="(e) => tagRemoved(e)"/>
                </div>
              </div>
            </div>
            <!-- Target Size -->
            <div class="d-flex flex-wrap align-items-center">
              <span>Availability: </span>
              <div class="d-flex flex-wrap">
                <div class="p-1" v-for="tag in resource.tags.filter((x) => x.type === 'availability')" :key="tag.id">
                  <resource-tag v-bind:tag="tag" v-bind:resource-i-d="resource.id" v-on:tagRemoved="(e) => tagRemoved(e)"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <single-resource-form v-if="isEditing" v-bind:editorType="editorType" v-bind:resource="resource" v-on:successfulEdit="hideEditor"/>
      </transition>
    </div>
  </div>
</template>

<script>
import SingleResourceForm from './SingleResourceForm'
import ResourceTagAdder from './ResourceTagAdder'
import ResourceTag from './ResourceTag'
export default {
  name: '',
  props: ['resource'],
  components: {SingleResourceForm, ResourceTag, ResourceTagAdder},
  computed: {
    location () {
      if (this.resource.city !== null && this.resource.country !== null) {
        if (this.resource.state !== null) {
          return this.resource.city + ", " + this.resource.state + ", " + this.resource.country
        } else {
          return this.resource.city + ", " + this.resource.country
        }
      }
      return 'NO LOCATION'
    }
  },
  methods: {
    setEditor(name) {
      if (this.isEditing && this.editorType === name) {
        this.hideEditor()
        return
      }
      this.editorType = name
      this.isEditing = true
    },
    hideEditor () {
      this.isEditing = false
      this.editorType = null
    },
    tagAdded (e) {
      this.resource.tags.push(e)
      this.showTagAdder = false
    },
    tagRemoved (e) {
      this.resource.tags = this.resource.tags.filter((x) => x.id !== e)
    }
  },
  data: function () {
    return {
      isEditing: false,
      editorType: null,
      showTagAdder: false
    }
  },

}
</script>

<style scoped>
  .fa-flag {
    color: #be1e2d;
  }
</style>



// WEBPACK FOOTER //
// src/components/startupResources/SingleResource.vue